module.exports = __webpack_public_path__ + "img/faq-danger.6deb958b.svg";